const SELECTORS = {
	emailElement: '.email-event',
	phoneElement: '.phone-event',
};

export class googleAnalytics {
	constructor() {
		this.emailElement = document.querySelectorAll(SELECTORS.emailElement);
		this.phoneElement = document.querySelectorAll(SELECTORS.phoneElement);

		const requiredElements = [this.emailElement, this.phoneElement];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new googleAnalytics();
	}

	static onEmailClick() {
		window.dataLayer.push({
			event: 'email_click',
		});
	}

	static onPhoneClick() {
		window.dataLayer.push({
			event: 'phone_click',
		});
	}

	/**
	 * Setup all event listeners used by the component.
	 */
	setupEventListeners() {
		this.emailElement.forEach((el) => el.addEventListener('click', googleAnalytics.onEmailClick));
		this.phoneElement.forEach((el) => el.addEventListener('click', googleAnalytics.onPhoneClick));
	}

	setup() {
		this.setupEventListeners();
	}
}
